(function () {
  const moneyFormat = window.AubeMoneyFormat || "${{amount}}";

  function formatMoney(cents) {
    const value = (Number(cents || 0) / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function cartEndpoint(path) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
    const cleanRoot = root.endsWith("/") ? root : `${root}/`;
    return `${cleanRoot}${path.replace(/^\/+/, "")}`;
  }

  function parseJsonResponse(response) {
    if (!response.ok) {
      throw new Error("Request failed");
    }
    return response.json();
  }

  function getCartErrorMessage(error) {
    return error.message || "Unable to add to cart";
  }

  function updateCartBadges(cart) {
    if (!cart) return;
    document.querySelectorAll(".cart-quantity, .aube-cart-badge").forEach((node) => {
      node.textContent = cart.item_count;
      node.hidden = cart.item_count === 0;
    });
  }

  function setupNav() {
    const toggle = document.querySelector("[data-nav-toggle]");
    const menu = document.querySelector("[data-nav-menu]");
    if (toggle && menu) {
      const mobileQuery = window.matchMedia("(max-width: 991px)");
      const syncMenuHeight = () => {
        if (!mobileQuery.matches) {
          menu.style.height = "";
          return;
        }
        const open = toggle.getAttribute("aria-expanded") === "true";
        menu.style.height = open ? "100dvh" : "0px";
      };
      syncMenuHeight();
      mobileQuery.addEventListener("change", syncMenuHeight);
      toggle.addEventListener("click", () => {
        const open = toggle.getAttribute("aria-expanded") !== "true";
        toggle.setAttribute("aria-expanded", String(open));
        syncMenuHeight();
      });
    }

    document.querySelectorAll("[data-submenu-toggle]").forEach((button) => {
      const nav = button.parentElement ? button.parentElement.querySelector("nav") : null;
      if (!nav) return;

      const setOpen = (open) => {
        button.setAttribute("aria-expanded", String(open));
        nav.hidden = !open;
      };

      button.addEventListener("click", () => {
        setOpen(button.getAttribute("aria-expanded") !== "true");
      });

      const wrap = button.closest(".aube-nav-submenu-wrap");
      if (wrap) {
        wrap.addEventListener("mouseenter", () => {
          if (window.matchMedia("(min-width: 992px)").matches) setOpen(true);
        });
        wrap.addEventListener("mouseleave", () => {
          if (window.matchMedia("(min-width: 992px)").matches) setOpen(false);
        });
      }
    });
  }

  function setupQuantityControls(root) {
    (root || document).querySelectorAll("[data-quantity-selector]").forEach((selector) => {
      if (selector.dataset.ready === "true") return;
      selector.dataset.ready = "true";

      const input = selector.querySelector("[data-quantity-input]");
      const minus = selector.querySelector("[data-quantity-minus]");
      const plus = selector.querySelector("[data-quantity-plus]");
      if (!input || !minus || !plus) return;

      minus.addEventListener("click", () => {
        const min = Number(input.min || 1);
        input.value = String(Math.max(min, Number(input.value || min) - 1));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });

      plus.addEventListener("click", () => {
        const max = Number(input.max || 99);
        input.value = String(Math.min(max, Number(input.value || 1) + 1));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  function setupVariantSelectors() {
    document.querySelectorAll("[data-product-variant-select]").forEach((select) => {
      const form = select.closest("form");
      const price = document.querySelector("[data-product-price]");
      const stock = document.querySelector("[data-product-stock]");
      const submit = form ? form.querySelector('button[type="submit"]') : null;

      select.addEventListener("change", () => {
        const option = select.options[select.selectedIndex];
        const available = option.dataset.available === "true";
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (stock) {
          stock.textContent = available ? "In Stock" : "Sold Out";
          stock.dataset.available = String(available);
        }
        if (submit) {
          submit.disabled = !available;
          const submitLabel = submit.querySelector(".aube-product-submit__label");
          if (submitLabel) {
            submitLabel.textContent = available ? "Add to Cart" : "Sold Out";
          } else {
            submit.textContent = available ? "Add to Cart" : "Sold Out";
          }
        }
      });
    });
  }

  function getAppstleSellingPlanId(selection) {
    if (!selection || typeof selection !== "object") return "";

    let candidate =
      selection.selling_plan_id ||
      selection.sellingPlanId ||
      selection.id ||
      selection.selling_plan ||
      "";

    if (candidate && typeof candidate === "object") {
      candidate =
        candidate.selling_plan_id ||
        candidate.sellingPlanId ||
        candidate.id ||
        "";
    }

    return candidate ? String(candidate) : "";
  }

  function syncAppstleSellingPlanInput(form) {
    if (!form) return;

    const input = form.querySelector("[data-appstle-selling-plan-input]");
    const submit = form.querySelector("[data-product-id]");
    const productId = submit && submit.dataset.productId ? Number(submit.dataset.productId) : 0;

    if (!input || !productId || typeof window.getSelectedSellingPlanByProductId !== "function") return;

    const selection = window.getSelectedSellingPlanByProductId(productId);
    const sellingPlanId = getAppstleSellingPlanId(selection);

    if (sellingPlanId) {
      input.value = sellingPlanId;
      input.disabled = false;
    } else {
      input.value = "";
      input.disabled = true;
    }
  }

  function initAppstleSubscriptionWidgets() {
    document.querySelectorAll("form.product-form").forEach((form) => {
      const input = form.querySelector("[data-appstle-selling-plan-input]");
      const submit = form.querySelector("[data-product-id]");
      const productId = submit && submit.dataset.productId ? Number(submit.dataset.productId) : 0;
      if (!input || !productId || form.dataset.appstleReady === "true") return;

      function tryInit() {
        syncAppstleSellingPlanInput(form);

        if (
          typeof window.subscribeToWidgetChangeByProductId === "function" &&
          form.dataset.appstleListenerReady !== "true"
        ) {
          window.subscribeToWidgetChangeByProductId(productId, () => syncAppstleSellingPlanInput(form));
          form.dataset.appstleListenerReady = "true";
          form.dataset.appstleReady = "true";
          return true;
        }

        return typeof window.getSelectedSellingPlanByProductId === "function";
      }

      if (tryInit()) {
        form.dataset.appstleReady = "true";
        return;
      }

      let retryCount = 0;
      const retryTimer = window.setInterval(() => {
        retryCount += 1;
        if (tryInit() || retryCount >= 20) {
          window.clearInterval(retryTimer);
        }
      }, 250);
    });
  }

  function setupAccordions() {
    document.querySelectorAll("[data-accordion-trigger]").forEach((button) => {
      if (button.dataset.ready === "true") return;
      button.dataset.ready = "true";
      button.addEventListener("click", () => {
        const item = button.closest("[data-accordion-item]");
        const content = item ? item.querySelector(".aube-product-accordion__content") : null;
        if (!item || !content) return;
        const open = item.getAttribute("data-state") === "open";
        item.setAttribute("data-state", open ? "closed" : "open");
        content.hidden = open;
      });
    });
  }

  function setupTimelyButtons() {
    const buttons = document.querySelectorAll("[data-timely-button]");
    if (!buttons.length) return;

    let timelyApi = null;
    const scriptId = "timelyScript";
    const scriptSrc = "https://book.gettimely.com/widget/book-button-v1.5.js";

    function loadTimely() {
      return new Promise((resolve, reject) => {
        if (window.timelyButton) {
          resolve();
          return;
        }
        const existing = document.getElementById(scriptId);
        if (existing) {
          existing.addEventListener("load", resolve, { once: true });
          existing.addEventListener("error", reject, { once: true });
          return;
        }
        const script = document.createElement("script");
        script.id = scriptId;
        script.src = scriptSrc;
        script.async = true;
        script.addEventListener("load", resolve, { once: true });
        script.addEventListener("error", reject, { once: true });
        document.head.appendChild(script);
      });
    }

    loadTimely()
      .then(() => {
        if (window.timelyButton) {
          timelyApi = new window.timelyButton("infoaubehairconz", { style: "dark", dontCreateButton: true });
          document.querySelectorAll(".aube-timely-button").forEach((node) => {
            node.dataset.ready = "true";
          });
        }
      })
      .catch(() => {});

    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        if (!timelyApi) return;
        event.preventDefault();
        timelyApi.start();
      });
    });
  }

  function setupCartDrawer() {
    const cartIcon = document.getElementById("cart-icon");
    const drawer = document.getElementById("side-cart");
    const overlay = document.getElementById("side-cart-overlay");
    const close = document.getElementById("side-cart-close");
    const itemsNode = document.getElementById("side-cart-items");
    const subtotalNode = document.getElementById("side-cart-subtotal");
    if (!drawer || !overlay || !close || !itemsNode || !subtotalNode) return;
    if (drawer.dataset.cartDrawerReady === "true") return;
    drawer.dataset.cartDrawerReady = "true";

    function openDrawer() {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      overlay.hidden = false;
      overlay.classList.add("is-open");
      loadCart();
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      overlay.classList.remove("is-open");
      overlay.hidden = true;
    }

    function renderCart(cart) {
      subtotalNode.textContent = formatMoney(cart.total_price);
      updateCartBadges(cart);

      if (!cart.items.length) {
        itemsNode.innerHTML = "<p>Your cart is empty.</p>";
        return;
      }

      itemsNode.innerHTML = cart.items
        .map((item, index) => {
          const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}">` : "";
          return `
            <article class="aube-cart-item">
              <a href="${escapeHtml(item.url)}">${image}</a>
              <div class="aube-cart-item__content">
                <a href="${escapeHtml(item.url)}"><h4>${escapeHtml(item.product_title)}</h4></a>
                <p>${formatMoney(item.final_price)}</p>
                <div class="aube-cart-qty" data-quantity-selector data-line="${index + 1}">
                  <button type="button" data-quantity-minus aria-label="Decrease quantity">-</button>
                  <input type="number" min="1" max="99" value="${item.quantity}" data-quantity-input aria-label="Quantity">
                  <button type="button" data-quantity-plus aria-label="Increase quantity">+</button>
                </div>
                <button class="aube-cart-remove" type="button" data-remove-line="${index + 1}">Remove</button>
              </div>
            </article>
          `;
        })
        .join("");

      setupQuantityControls(itemsNode);
      itemsNode.querySelectorAll("[data-line]").forEach((selector) => {
        const input = selector.querySelector("[data-quantity-input]");
        input.addEventListener("change", () => updateCartItem(selector.dataset.line, input.value));
      });
      itemsNode.querySelectorAll("[data-remove-line]").forEach((button) => {
        button.addEventListener("click", () => updateCartItem(button.dataset.removeLine, 0));
      });
    }

    function loadCart() {
      return fetch("/cart.js")
        .then(parseJsonResponse)
        .then(renderCart)
        .catch(() => {});
    }

    function updateCartItem(line, quantity) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      })
        .then(parseJsonResponse)
        .then(renderCart);
    }

    window.loadCart = loadCart;
    window.openCartDrawer = openDrawer;
    window.openCart = openDrawer;
    window.closeCart = closeDrawer;

    if (cartIcon) {
      cartIcon.addEventListener("click", (event) => {
        event.preventDefault();
        openDrawer();
      });
    }
    document.addEventListener("click", (event) => {
      const cartLink = event.target.closest('a[href="#cart"], [data-cart-open]');
      if (!cartLink) return;
      event.preventDefault();
      openDrawer();
    });
    document.addEventListener("click", (event) => {
      const cartClose = event.target.closest("[data-cart-close]");
      if (!cartClose) return;
      event.preventDefault();
      closeDrawer();
    });
    close.addEventListener("click", closeDrawer);
    overlay.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeDrawer();
    });
  }

  function isProductForm(form) {
    if (!form) return false;
    return form.classList.contains("pdp-form") || form.classList.contains("product-form");
  }

  function formHasOneTimePurchaseSelected(form) {
    const checkedPurchaseType = form && form.querySelector("[data-plan-type]:checked");
    const sellingPlanInput = form && form.querySelector("[data-selling-plan-input]");
    return !!(
      checkedPurchaseType &&
      checkedPurchaseType.dataset.planType === "onetime" &&
      sellingPlanInput
    );
  }

  function submitProductForm(form) {
    const submitButton = form.querySelector('[type="submit"]');
    const errorTarget = form.querySelector("[data-product-error], [data-product-form-status]");
    if (errorTarget) {
      errorTarget.hidden = true;
      errorTarget.textContent = "";
    }
    if (submitButton) submitButton.setAttribute("aria-busy", "true");

    syncAppstleSellingPlanInput(form);
    const formData = new FormData(form);
    const appstleSellingPlanInput = form.querySelector("[data-appstle-selling-plan-input]");
    if (appstleSellingPlanInput) {
      formData.delete("selling_plan");
      if (!appstleSellingPlanInput.disabled && appstleSellingPlanInput.value) {
        formData.append("selling_plan", appstleSellingPlanInput.value);
      }
    }
    if (formHasOneTimePurchaseSelected(form)) {
      formData.delete("selling_plan");
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error("Unable to add to cart");
        }
        return response.json();
      })
      .then(function() {
        if (typeof window.openCart === "function") {
          window.openCart();
        } else if (typeof window.openCartDrawer === "function") {
          window.openCartDrawer();
        } else if (typeof window.loadCart === "function") {
          window.loadCart();
        }
      })
      .catch(function(error) {
        if (errorTarget) {
          errorTarget.hidden = false;
          errorTarget.textContent = getCartErrorMessage(error);
        }
      })
      .finally(function() {
        if (submitButton) submitButton.removeAttribute("aria-busy");
      });
  }

  function setupProductForms() {
    if (document.documentElement.dataset.productFormsReady === "true") return;
    document.documentElement.dataset.productFormsReady = "true";

    document.addEventListener("submit", function(event) {
      const form = event.target.closest("form");
      if (!isProductForm(form)) return;
      event.preventDefault();
      submitProductForm(form);
    });
  }

  function setupContactForms() {
    document.querySelectorAll(".aube-contact-form").forEach((form) => {
      form.addEventListener("submit", (event) => {
        form.classList.add("was-validated");
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });
  }

  function googleReviewStars(rating) {
    return String.fromCharCode(9733).repeat(Number(rating || 0));
  }

  function loadGoogleReviews(source) {
    window.AubeGoogleReviewSources = window.AubeGoogleReviewSources || {};
    if (!window.AubeGoogleReviewSources[source]) {
      window.AubeGoogleReviewSources[source] = fetch(source)
        .then(parseJsonResponse)
        .catch(() => []);
    }
    return window.AubeGoogleReviewSources[source];
  }

  function googleReviewUrl(review) {
    return review.reviewUrl || review.url || review.link || review.shareUrl || "";
  }

  function googleProfilePhotoUrl(url) {
    const value = String(url || "");
    // Avatars are stored locally in assets/ because Google's CDN links expire.
    // A bare filename resolves against the theme assets folder; absolute URLs pass through.
    if (value && !/^https?:\/\//.test(value) && value.charAt(0) !== "/") {
      return googleAssetBase + value;
    }
    return value
      .replace(/-ba\d+(?=-br\d+)/, "")
      .replace(/=s\d+/, "=s96");
  }

  // Set from the section's data-google-reviews-source, e.g.
  // "/cdn/shop/t/6/assets/google-reviews.json?v=123" -> "/cdn/shop/t/6/assets/"
  let googleAssetBase = "";

  function setGoogleAssetBase(source) {
    googleAssetBase = String(source || "").split("?")[0].replace(/[^/]+$/, "");
  }

  function googleReviewPhotoUrl(url, review) {
    const value = String(url || "");
    // Review photos are stored locally in assets/ because Google's CDN links expire.
    // A bare filename resolves against the theme assets folder; absolute URLs pass through.
    if (value && !/^https?:\/\//.test(value) && value.charAt(0) !== "/") {
      return googleAssetBase + value;
    }
    const size = slugifyGoogleReviewName(review && review.name) === "muskan-maan"
      ? "=w900-h1200-p-k-no"
      : "=w900-h900-p-k-no";
    return value.replace(/=s\d+-p-k-rw$/, size);
  }

  function googleReviewDate(review) {
    return String(review.date || "").replace(/New$/, "").trim();
  }

  function featuredGoogleReviewNames(value) {
    return String(value || "")
      .split(/[\n,]+/)
      .map((name) => name.trim())
      .filter(Boolean);
  }

  function renderGoogleMark() {
    return `
      <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
        <path fill="#4285f4" d="M45.1 24.5c0-1.6-.1-3.1-.4-4.5H24v8.5h11.8c-.5 2.7-2 5-4.4 6.6v5.5h7.1c4.2-3.8 6.6-9.5 6.6-16.1Z"></path>
        <path fill="#34a853" d="M24 46c5.9 0 10.9-2 14.6-5.4l-7.1-5.5c-2 1.3-4.5 2.1-7.5 2.1-5.7 0-10.5-3.8-12.2-9H4.5v5.7C8.1 41 15.5 46 24 46Z"></path>
        <path fill="#fbbc05" d="M11.8 28.2c-.4-1.3-.7-2.7-.7-4.2s.2-2.9.7-4.2v-5.7H4.5C3 17 2 20.4 2 24s1 7 2.5 9.9l7.3-5.7Z"></path>
        <path fill="#ea4335" d="M24 10.8c3.2 0 6.1 1.1 8.4 3.3l6.3-6.3C34.9 4.2 29.9 2 24 2 15.5 2 8.1 7 4.5 14.1l7.3 5.7c1.7-5.2 6.5-9 12.2-9Z"></path>
      </svg>
    `;
  }

  function renderGoogleReviewer(review, options) {
    const settings = options || {};
    const url = googleReviewUrl(review);
    const tagName = settings.nameTag || "h3";
    const linkedAttrs = url && url !== "#"
      ? ` href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer"`
      : "";
    const nameMarkup = linkedAttrs
      ? `<a${linkedAttrs}>${escapeHtml(review.name)}</a>`
      : `<span>${escapeHtml(review.name)}</span>`;
    const googleMarkup = linkedAttrs
      ? `<a class="aube-google-reviewer__google aube-review-tooltip" ${linkedAttrs} data-tooltip="Posted on Google" aria-label="Posted on Google">${renderGoogleMark()}</a>`
      : `<span class="aube-google-reviewer__google aube-review-tooltip" data-tooltip="Posted on Google" aria-label="Posted on Google">${renderGoogleMark()}</span>`;
    const verifiedMarkup = linkedAttrs
      ? `<a class="aube-google-verified aube-review-tooltip" ${linkedAttrs} data-tooltip="Verified customer" aria-label="Verified customer">`
      : `<span class="aube-google-verified aube-review-tooltip" data-tooltip="Verified customer" aria-label="Verified customer">`;
    const verifiedClose = linkedAttrs ? "</a>" : "</span>";

    return `
      <div class="aube-google-reviewer">
        <div class="aube-google-reviewer__avatar">
          <img class="aube-google-reviewer__photo" src="${escapeHtml(googleProfilePhotoUrl(review.profilePhoto))}" alt="" width="56" height="56" loading="lazy">
          ${googleMarkup}
        </div>
        <div class="aube-google-reviewer__body">
          <${tagName} class="aube-google-reviewer__name">
            ${nameMarkup}
            ${verifiedMarkup}
              <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <path d="M6.6 11.4 3.4 8.2l1.4-1.4 1.8 1.8 4.6-4.8 1.4 1.4-6 6.2Z"></path>
              </svg>
            ${verifiedClose}
          </${tagName}>
          <div class="aube-google-reviewer__meta">
            <p class="aube-google-stars" aria-label="${escapeHtml(review.rating)} out of 5 stars">${googleReviewStars(review.rating)}</p>
            <p>${escapeHtml(googleReviewDate(review))}</p>
          </div>
        </div>
      </div>
    `;
  }

  function renderGoogleReviewCard(review, options) {
    return `
      <article class="aube-google-review-card" data-animate="reveal" data-animate-y="28" data-animate-duration="0.65" data-animate-scale="0.99">
        ${renderGoogleReviewer(review, { ...options, nameTag: "h3" })}
        <p class="aube-google-review-card__text">${escapeHtml(review.text)}</p>
      </article>
    `;
  }

  function shortGoogleReviewText(text, limit) {
    const value = String(text || "").replace(/\s+/g, " ").trim();
    return value.length > limit ? `${value.slice(0, limit).trim()}...` : value;
  }

  function slugifyGoogleReviewName(name) {
    return String(name || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function renderGoogleAutoplayCard(review) {
    const reviewUrl = googleReviewUrl(review);
    const textLimit = 320;
    const cleanText = String(review.text || "").replace(/\s+/g, " ").trim();
    const isTruncated = cleanText.length > textLimit;
    const readMore = isTruncated && reviewUrl
      ? `<a class="aube-photo-review-card__read-more" href="${escapeHtml(reviewUrl)}" target="_blank" rel="noopener noreferrer">Read more</a>`
      : "";


    return `
      <article class="aube-review-autoplay__card" data-animate="reveal" data-animate-y="24" data-animate-duration="0.62" data-animate-scale="0.99">
        <blockquote>${escapeHtml(shortGoogleReviewText(review.text, textLimit))}${readMore ? ` ${readMore}` : ""}</blockquote>
        <footer>${renderGoogleReviewer(review, { nameTag: "strong" })}</footer>
      </article>
    `;
  }

  function renderGooglePhotoReviewCard(item) {
    const { review, photo, photoIndex } = item;
    const reviewUrl = googleReviewUrl(review);
    const textLimit = photoIndex === 0 ? 260 : 180;
    const cleanText = String(review.text || "").replace(/\s+/g, " ").trim();
    const isTruncated = cleanText.length > textLimit;
    const readMore = isTruncated && reviewUrl
      ? `<a class="aube-photo-review-card__read-more" href="${escapeHtml(reviewUrl)}" target="_blank" rel="noopener noreferrer">Read more</a>`
      : "";
    const image = `<img src="${escapeHtml(googleReviewPhotoUrl(photo.src, review))}" alt="${escapeHtml(photo.alt || `Photo from ${review.name} review`)}" width="900" height="900" loading="lazy">`;
    const imageMarkup = reviewUrl
      ? `<a class="aube-photo-review-card__image" href="${escapeHtml(reviewUrl)}" target="_blank" rel="noopener noreferrer" aria-label="Open ${escapeHtml(review.name)} review on Google">${image}</a>`
      : `<div class="aube-photo-review-card__image">${image}</div>`;

    return `
      <article class="aube-photo-review-card" data-reviewer="${escapeHtml(slugifyGoogleReviewName(review.name))}" data-photo-index="${escapeHtml(photoIndex)}" data-animate="reveal" data-animate-y="30" data-animate-duration="0.65" data-animate-scale="0.985">
        ${imageMarkup}
        <div class="aube-photo-review-card__body">
          ${renderGoogleReviewer(review, { nameTag: "h3" })}
          <p>${escapeHtml(shortGoogleReviewText(review.text, textLimit))}${readMore ? ` ${readMore}` : ""}</p>
        </div>
      </article>
    `;
  }

  function setupGooglePhotoReviews(root, reviews) {
    if (root.dataset.ready === "true") return;
    const grid = root.querySelector("[data-google-photo-review-grid]");
    if (!grid) return;

    const photoReviews = reviews
      .filter((review) => Number(review.rating) === 5 && String(review.text || "").trim() && Array.isArray(review.photos) && review.photos.length)
      .map((review) => ({ review, photo: review.photos[0], photoIndex: 0 }));

    grid.innerHTML = photoReviews.map(renderGooglePhotoReviewCard).join("");
    root.dataset.ready = "true";
  }

  function setupGoogleReviewAutoplay(root, reviews) {
    if (root.dataset.ready === "true") return;
    const track = root.querySelector("[data-google-autoplay-track]");
    const dots = root.querySelector("[data-google-autoplay-dots]");
    const previous = root.querySelector("[data-google-autoplay-previous]");
    const next = root.querySelector("[data-google-autoplay-next]");
    if (!track || !dots || !previous || !next) return;
    const defaultSelectedNames = [
      "Gemma Lloyd",
      "Rachel",
      "Naomi Robbins",
      "Taichi Kojima",
      "Monique Smith",
      "Sonia Sutherland",
      "Maria Ramirez",
      "Awhi Pearce"
    ];
    const selectedNames = featuredGoogleReviewNames(root.dataset.featuredReviewNames);
    const requestedNames = selectedNames.length ? selectedNames : defaultSelectedNames;
    const selected = requestedNames
      .map((name) => reviews.find((review) => review.name === name && Number(review.rating) === 5 && review.text))
      .filter(Boolean);
    if (!selected.length) return;

    let activeIndex = 0;
    let timer;

    const update = () => {
      const card = track.querySelector(".aube-review-autoplay__card");
      if (!card) return;
      const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      track.style.transform = `translateX(-${activeIndex * (card.getBoundingClientRect().width + gap)}px)`;
      dots.querySelectorAll("[data-google-autoplay-dot]").forEach((dot, index) => {
        dot.setAttribute("aria-pressed", String(index === activeIndex));
      });
    };

    const move = (offset) => {
      activeIndex = (activeIndex + offset + selected.length) % selected.length;
      update();
    };

    const start = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => move(1), 6000);
    };

    track.innerHTML = selected.map(renderGoogleAutoplayCard).join("");
    dots.innerHTML = selected.map((_, index) => `
      <button type="button" aria-label="Show featured review ${index + 1}" aria-pressed="${index === activeIndex}" data-google-autoplay-dot="${index}"></button>
    `).join("");
    previous.addEventListener("click", () => {
      move(-1);
      start();
    });
    next.addEventListener("click", () => {
      move(1);
      start();
    });
    dots.addEventListener("click", (event) => {
      const button = event.target.closest("[data-google-autoplay-dot]");
      if (!button) return;
      activeIndex = Number(button.dataset.googleAutoplayDot);
      update();
      start();
    });
    root.addEventListener("mouseenter", () => window.clearInterval(timer));
    root.addEventListener("mouseleave", start);
    window.addEventListener("resize", update);
    update();
    start();
    root.dataset.ready = "true";
  }

  function setupGoogleReviewList(root, reviews) {
    if (root.dataset.ready === "true") return;
    const grid = root.querySelector("[data-google-review-grid]");
    const count = root.querySelector("[data-google-written-count]");
    if (!grid) return;
    const cardOptions = {};

    const writtenReviews = reviews.filter((review) => Number(review.rating) === 5 && String(review.text || "").trim());
    if (count) count.textContent = writtenReviews.length >= 100 ? "100+" : writtenReviews.length;

    grid.innerHTML = writtenReviews.map((review) => renderGoogleReviewCard(review, cardOptions)).join("");
    root.dataset.ready = "true";
  }

  function setupGoogleReviews() {
    document.querySelectorAll("[data-google-reviews-source]").forEach((root) => {
      const source = root.dataset.googleReviewsSource;
      if (!source) return;
      setGoogleAssetBase(source);
      loadGoogleReviews(source).then((reviews) => {
        if (root.matches("[data-google-review-autoplay]")) setupGoogleReviewAutoplay(root, reviews);
        if (root.matches("[data-google-photo-reviews]")) setupGooglePhotoReviews(root, reviews);
        if (root.matches("[data-google-review-list]")) setupGoogleReviewList(root, reviews);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    setupNav();
    setupQuantityControls(document);
    setupVariantSelectors();
    initAppstleSubscriptionWidgets();
    setupAccordions();
    setupTimelyButtons();
    setupContactForms();
    setupCartDrawer();
    setupProductForms();
    setupGoogleReviews();
    window.setTimeout(setupCartDrawer, 250);
    window.setTimeout(setupCartDrawer, 1000);
  });

  window.addEventListener("load", setupCartDrawer);
  document.addEventListener("shopify:section:load", () => {
    setupCartDrawer();
    setupProductForms();
    initAppstleSubscriptionWidgets();
    setupGoogleReviews();
  });
})();
